// This is very hacky
// We produce a select box for all portfolio-cats on smaller screens

(function($){
  $(document).ready(($) => {
    const $window = $(window)
    const h1 = $("h1.entry-title");
    let selectBoxExist = false;

    /**
     * Create selectbox from h1 portfolio-cat links
     */
    function selectBox() {
      const cats = $("h1 > .portfolio-cat");
      if(selectBoxExist || cats.length === 0) {
        return
      }
      selectBoxExist = true;
      const dropdown = $("<select/>", {"class": "dropdown form-control mb-4 mt-2"})
        .append($("<option/>", {"value": "", "disabled": "true", "selected": "true"}).text("Arbeiten filtern"));

      cats.each(function(i,d) {
        const li = $("<option/>", {"value": $(d).attr("href")}).text($(d).text())
        dropdown.append(li)
      });
      dropdown.on("change", function() {
        if($(this).val() !== "") {
          window.location.href = $(this).val()
        }
      });
      h1.hide();
      h1.after(dropdown);
    }

    /**
     * Remove select box for mobile devices
     */
    function unselectBox() {
      $("select.dropdown").remove();
      h1.show();
      selectBoxExist = false;
    }

    $window.on('resize', () => {
      if($window.width() > 768) {
        unselectBox()
      } else {
        selectBox();
      }
    });
    // initial trigger
    $window.trigger("resize");
  })
})(jQuery)
